"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.randomStr = void 0;
/**
 * Returns a string of random alphanumeric characters.
 */
exports.randomStr = function () {
    return Math.random()
        .toString(36)
        .substr(2);
};
exports.capitalize = function (word) {
    return word.charAt(0).toLocaleUpperCase() + word.slice(1);
};
//# sourceMappingURL=string.js.map